import { render, staticRenderFns } from "./SubmenuItem.vue?vue&type=template&id=1ae070ff&"
import script from "./SubmenuItem.vue?vue&type=script&lang=js&"
export * from "./SubmenuItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports